import React from 'react';
import PropTypes from 'prop-types';

const CalendarIcon = ({ className }) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="20"
    viewBox="0 0 18 20"
  >
    <path
      d="M17.25 13.71V2.75c0-.756-.619-1.375-1.375-1.375H14.5V.687a.688.688 0 0 0-1.375 0v.688h-8.25V.687a.688.688 0 0 0-1.375 0v.688H2.125C1.369 1.375.75 1.994.75 2.75v15.125c0 .756.619 1.375 1.375 1.375h9.57l.008.001.007-.001h.04v-.008a.678.678 0 0 0 .439-.192l4.86-4.861a.678.678 0 0 0 .193-.439h.008v-.04zM3.5 2.75v.688a.687.687 0 1 0 1.375 0V2.75h8.25v.688a.688.688 0 0 0 1.375 0V2.75h1.375V5.5H2.125V2.75H3.5zM2.125 6.875h13.75v5.5H11.75c-.756 0-1.375.619-1.375 1.375v4.125h-8.25v-11zm9.625 10.67V13.75h3.794l-3.794 3.794z"
    />
  </svg>
);

CalendarIcon.propTypes = {
  className: PropTypes.string
};

CalendarIcon.defaultProps = {
  className: undefined
};

export default CalendarIcon;
